import { colours } from "@shared/ui.design-system";
import { HeartIcon, HeartOutlineIcon } from "@shared/ui.icons";
import React from "react";

import {
  verticalProductCardWishlistButton,
  verticalProductCardWishlistContainer
} from "./VerticalProductCard.css";
import type { ProductCardDataType } from "./types";

export interface VerticalProductCardWishlistProps {
  onToggle: (productCardData: ProductCardDataType) => void;
  product: ProductCardDataType;
}

export const VerticalProductCardWishlist: React.FC<
  VerticalProductCardWishlistProps
> = ({ onToggle, product }) => {
  const handleToggleWishlist = (
    event: React.MouseEvent | React.KeyboardEvent
  ) => {
    event.stopPropagation();
    event.preventDefault();
    event.nativeEvent.stopImmediatePropagation();
    onToggle(product);
  };

  return (
    <div className={verticalProductCardWishlistContainer}>
      <button
        className={verticalProductCardWishlistButton}
        onClick={handleToggleWishlist}
        data-testid="wishlist-button"
        aria-label={
          product.inWishlist ? "Remove from wishlist" : "Add to wishlist"
        }
      >
        {product.inWishlist ? (
          <HeartIcon
            data-testid="heart-filled-icon"
            width={20}
            height={20}
            fill={colours.accent.strong}
          />
        ) : (
          <HeartOutlineIcon
            data-testid="heart-outline-icon"
            width={20}
            height={20}
            fill={colours.primary.dark}
          />
        )}
      </button>
    </div>
  );
};
